module.exports = __webpack_public_path__ + "static/media/Explore_activities_button.9b3202c4.mp3";